"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerToggleButton = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./DrawerToggleButton.css"));
var NavigationContext_1 = require("./NavigationContext");
var react_2 = require("react");
var PubSub_1 = require("../PubSub/PubSub");
var DrawerToggleButton = function () {
    var isOpen = (0, NavigationContext_1.useNavigationContext)().isNavDrawerOpen;
    var buttonRef = (0, react_1.useRef)(null);
    var _a = __read(react_1.default.useState(false), 2), isCoarseDevice = _a[0], setIsCoarseDevice = _a[1];
    (0, react_2.useEffect)(function () {
        var coarseMediaQuery = window.matchMedia("(pointer: coarse)");
        var onMediaChange = function (mediaQueryListEvent) {
            setIsCoarseDevice(mediaQueryListEvent.matches);
        };
        coarseMediaQuery.addEventListener("change", onMediaChange);
        setIsCoarseDevice(coarseMediaQuery.matches);
        return function () {
            coarseMediaQuery.removeEventListener("change", onMediaChange);
        };
    }, []);
    var handleClick = function () {
        PubSub_1.PubSub.publish("qwilr:nav-drawer-toggled", { isOpen: !isOpen, reason: "toggle-button-clicked" });
    };
    (0, react_2.useEffect)(function () {
        return PubSub_1.PubSub.subscribe("qwilr:nav-drawer-toggled", function (_a) {
            var isOpen = _a.isOpen, reason = _a.reason;
            if (!isOpen && reason === "escape-pressed-in-drawer" && buttonRef.current) {
                buttonRef.current.focus({ preventScroll: true });
            }
        });
    });
    return (react_1.default.createElement(kaleidoscope_1.IconButton, { ref: buttonRef, icon: react_1.default.createElement(NavigationIcon, { isOpen: isOpen }), onClick: handleClick, tooltip: isCoarseDevice ? undefined : { content: "Menu", position: kaleidoscope_1.TooltipPosition.Bottom }, "aria-expanded": isOpen }));
};
exports.DrawerToggleButton = DrawerToggleButton;
var NavigationIcon = function (_a) {
    var isOpen = _a.isOpen;
    return (react_1.default.createElement("svg", { className: styles.icon, width: "24", height: "24", viewBox: "0 0 24 24" },
        react_1.default.createElement("rect", { className: styles.iconBar({ open: isOpen }), x: "2", y: "17", rx: "1" }),
        react_1.default.createElement("rect", { className: styles.iconArrow({ open: isOpen, position: "bottom" }), x: "2", y: "11", rx: "1" }),
        react_1.default.createElement("rect", { className: styles.iconBar(), x: "2", y: "11", rx: "1" }),
        react_1.default.createElement("rect", { className: styles.iconArrow({ open: isOpen, position: "top" }), x: "2", y: "11", rx: "1" }),
        react_1.default.createElement("rect", { className: styles.iconBar({ open: isOpen }), x: "2", y: "5", rx: "1" })));
};
